import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ApNotificationComponent } from '@ap/notification';

import { TokenEndpointInterceptor } from '../../../interceptors/token-endpoint/token-endpoint.interceptor';
import { MijnKlantConversationalModule } from '../mijn-klant-conversational.module';

import { WrapperComponent } from './wrapper.component';

@NgModule({
    imports: [BrowserModule, ApNotificationComponent, MijnKlantConversationalModule],
    declarations: [WrapperComponent],
    exports: [WrapperComponent],
    bootstrap: [WrapperComponent],
    providers: [{ provide: HTTP_INTERCEPTORS, useClass: TokenEndpointInterceptor, multi: true }]
})
export class WrapperModule {}
